<template>
  <div>
    <div class="row toolbar-row">
      <div
      v-if="!loggedInUserData.is_staff"
        class="col-sm-6 col-md-3 text-left"
      >
        <v-btn
          style="height: auto; padding-left: 0px; padding-right: 0px"
          to="/make-new-order"
          depressed
        >
          <i
              style="font-size: 23px;"
              class="material-icons" :class="loggedInUserData.is_staff ? 'blue-logout' : 'orange-logout'"
            >add_box</i>&nbsp;
          {{ $t('datatable.newOrderButton') }}
        </v-btn>
      </div>
      <div
        v-if="!hideReloadButton && (addExportButton || addPrepareToPrintButton)"
        class="col-sm-4 col-md-2 text-left"
      >
        <v-btn
          style="height: auto; padding-left: 0px; padding-right: 0px"
          @click="
            resetGetResults()
            filterApplied = false
            resetDatePickerDefaults()
            ware = 'Select'
          "
          depressed
        >
          <v-icon
            icon
            :class="loggedInUserData.is_staff ? 'blue-logout' : 'orange-logout'"
          >cached</v-icon>&nbsp; {{ $t('datatable.reloadTableButton') }}
        </v-btn>
      </div>
      <div
        v-if="!hideReloadButton && !(addExportButton || addPrepareToPrintButton)"
        class="text-left" :class="!loggedInUserData.is_staff ? 'col-sm-4 col-md-3' : 'col-sm-6 col-md-6'"
        style="padding-top: 4px"
      >
        <v-btn
          style="height: auto"
          @click="
            resetGetResults()
            filterApplied = false
            resetDatePickerDefaults()
            ware = 'Select'
          "
          depressed
        >
          <v-icon
            icon
            :class="loggedInUserData.is_staff ? 'blue-logout' : 'orange-logout'"
          >cached</v-icon>&nbsp; {{ $t('datatable.reloadTableButton') }}
        </v-btn>
      </div>

      <div
        v-if="addExportButton"
        class="col-sm-6 col-md-2 text-left"
      >
        <v-btn
          style="height: auto; padding-left: 0px; padding-right: 0px"
          @click="sendToExport"
          depressed
        >
          <v-icon :class="loggedInUserData.is_staff ? 'blue-logout' : 'orange-logout'">explicit</v-icon>&nbsp; {{ $t('datatable.exportButton') }}
        </v-btn>
      </div>

      <div
        v-if="addPrepareToPrintButton"
        class="col-sm-6 col-md-3 text-left"
      >
        <v-btn
          @click="prepareToPrint()"
          style="height: auto; padding-left: 0px; padding-right: 0px"
          depressed
        >
          <v-icon style="color: #006b8d">print</v-icon> &nbsp; {{ $t('datatable.prepareToPrintButton') }}
        </v-btn>
      </div>

      <div
        v-if="(showFastPaymentAll && $_has_perm(permissions.fast_payment_permission)) || (showReceiveAll && $_has_perm(permissions.receive_permission)) || (showUnreceiveAll && $_has_perm(permissions.unreceive_permission)) || addReceivePrintButton || (showOutOfficeAll && $_has_perm(permissions.out_office_permission)) || (addMergePrintButton && $_has_perm(permissions.merge_print_permission))"
        class="col-sm-12 col-md-12"
        style="margin-top: 8px;"
      >
        <div
          class="row toolbar-row"
          style="margin: 0;"
        >
          <div
            v-if="showFastPaymentAll && $_has_perm(permissions.fast_payment_permission)"
            class="col-sm-3 col-md-3 text-left"
          >
            <v-btn
              @click="confirmFastPaymentAll()"
              style="height: auto; padding-left: 0px; padding-right: 0px"
              depressed
            >
              <i
                class="material-icons"
                style="color: #2e7d32; font-size: 18px"
              >payments</i>&nbsp; {{ $t('datatable.fastPaymentButton') }}
            </v-btn>
          </div>

          <div
            v-if="addMergePrintButton && $_has_perm(permissions.merge_print_permission)"
            class="col-sm-3 col-md-3 text-left"
          >
            <v-btn
              @click="mergePrintList()"
              style="height: auto; padding-left: 0px; padding-right: 0px"
              depressed
            >
              <v-icon style="color: #6a1b9a">merge_type</v-icon> &nbsp; {{ $t('datatable.mergeAndPrintButton') }}
            </v-btn>
          </div>

          <div
            v-if="showReceiveAll && $_has_perm(permissions.receive_permission)"
            class="col-sm-3 col-md-3 text-left"
          >
            <v-btn
              @click="confirmReceiveAll()"
              style="height: auto; padding-left: 0px; padding-right: 0px"
              depressed
            >
              <i
                class="material-icons"
                style="color: #1565c0; font-size: 18px"
              >receipt</i>&nbsp; {{ $t('datatable.receiveButton') }}
            </v-btn>
          </div>

          <div
            v-if="showUnreceiveAll && $_has_perm(permissions.unreceive_permission)"
            class="col-sm-3 col-md-3 text-left"
          >
            <v-btn
              @click="confirmUnreceiveAll()"
              style="height: auto; padding-left: 0px; padding-right: 0px"
              depressed
            >
              <i
                class="material-icons"
                style="color: #c62828; font-size: 18px"
              >undo</i>&nbsp; {{ $t('datatable.unreceiveButton') }}
            </v-btn>
          </div>

          <div
            v-if="addReceivePrintButton"
            class="col-sm-3 col-md-3 text-left"
          >
            <v-btn
              @click="receivePrintList()"
              style="height: auto; padding-left: 0px; padding-right: 0px"
              depressed
            >
              <v-icon style="color: #006b8d">print</v-icon> &nbsp; {{ $t('datatable.printReceiveButton') }}
            </v-btn>
          </div>

          <div
            v-if="showOutOfficeAll && $_has_perm(permissions.out_office_permission)"
            class="col-sm-3 col-md-3 text-left"
          >
            <v-btn
              @click="confirmOutOfficeAll()"
              style="height: auto; padding-left: 0px; padding-right: 0px"
              depressed
            >
              <i
                class="material-icons"
                style="color: #c62828; font-size: 18px"
              >exit_to_app</i>&nbsp; {{ $t('datatable.outOfficeButton') }}
            </v-btn>
          </div>
        </div>
      </div>

      <div
        v-if="!removeAddButton"
        class="col-sm-6 col-md-6 text-right mobile"
      >
        <v-btn
          style="height: auto"
          depressed
        >
          <v-icon
            icon
            style="color: #006b8d"
            class="fa fa-plus fa-lg"
          > </v-icon> &nbsp;{{ $t('datatable.addNewButton') }}
        </v-btn>
      </div>
      <div
        v-if="showAddExportOrderButton"
        class="col-sm-6 col-md-6 text-right mobile"
      >
        <v-btn
          style="height: auto"
          depressed
          @click="handleAddExportOrder"
        >
          <v-icon
            icon
            style="color: #006b8d"
            class="fa fa-plus fa-lg mr-2"
          > </v-icon>
          {{ $t('datatable.addNewButton') }}
        </v-btn>
      </div>
      <div
        v-if="addQrCodeGenerateButton && $_has_perm(permissions.generate_qr_code)"
        class="col-sm-6 col-md-2 text-left"
      >
        <v-btn
          @click="openGenerateQrCodeModal()"
          style="height: auto; padding-right: 0px; padding-left: 0px"
          depressed
        ><i
            class="fa fa-qrcode fa-2x"
            aria-hidden="true"
          ></i> &nbsp;{{ $t('datatable.generateQrCodeButton') }}</v-btn>
      </div>
      <div
        v-if="addOrderInvoiceButton && (!permissions.add_shipping_invoice || $_has_perm(permissions.add_shipping_invoice))"
        class="col-sm-6 col-md-2 text-left"
      >
        <v-btn
          @click="openOrderInvoiceModal()"
          style="height: auto; padding-right: 0px; padding-left: 0px"
          depressed
        ><i
            class="fa fa-file-text-o mr-2 py-1"
            style="font-size: 18px"
            aria-hidden="true"
          ></i> &nbsp;{{ $t('datatable.generateInvoiceButton') }}</v-btn>
      </div>
      <!-- Attach to Delivery: source button is commented out in allOrder.vue/branchDeliveredOrder.vue
      for now (kept for later use), so showAttachToDeliveryButton is never passed as true currently. -->
      <div
        v-if="showAttachToDeliveryButton && $_has_perm(permissions.attach_to_delivery_permission)"
        class="col-sm-6 col-md-2 text-left"
      >
        <v-btn
          @click="attachToDelivery()"
          style="height: auto; padding-right: 0px; padding-left: 0px"
          depressed
        ><i
            class="fa fa-motorcycle mr-2 py-1"
            style="font-size: 18px"
            aria-hidden="true"
          ></i> &nbsp;{{ $t('datatable.attachToDeliveryButton') }}</v-btn>
      </div>
      <div
        v-if="showChangeStatusAll && $_has_perm(permissions.change_status_permission)"
        class="col-sm-6 col-md-2 text-left"
      >
        <v-btn
          @click="confirmChangeStatusAll()"
          style="height: auto; padding-right: 0px; padding-left: 0px"
          depressed
          small
        ><i
            class="material-icons"
            style="color: #6a1b9a; font-size: 18px"
          >autorenew</i>&nbsp;{{ $t('datatable.changeStatusButton') }}</v-btn>
      </div>
      <div
        v-if="addCustomerDeliverySummaryButton && $_has_perm(permissions.view_customer_delivery_summary)"
        class="col-sm-6 col-md-2 text-left"
      >
        <v-btn
          @click="openCustomerDeliverySummaryModal()"
          style="height: auto; padding-right: 0px; padding-left: 0px"
          depressed
          small
        ><i
            class="material-icons"
            style="color: #00897b; font-size: 18px"
          >groups</i>&nbsp;{{ $t('datatable.deliverySummaryButton') }}</v-btn>
      </div>
      <div
        v-if="addUnclearButton && $_has_perm(permissions.unclear_permission)"
        class="col-sm-6 col-md-2 text-left"
      >
        <v-btn
          @click="confirmUnclearAll()"
          style="height: auto; padding-right: 0px; padding-left: 0px"
          depressed
          small
        ><i
            class="material-icons"
            style="color: #c62828; font-size: 18px"
          >undo</i>&nbsp;{{ $t('datatable.unclearButton') }}</v-btn>
      </div>
      <div
        v-if="addSecondOrderInvoiceButton && $_has_perm(permissions.add_second_shipping_invoice)"
        class="col-sm-6 col-md-2 text-left"
      >
        <v-btn
          @click="openSecondOrderInvoiceModal()"
          style="height: auto; padding-right: 0px; padding-left: 0px"
          depressed
        ><i
            class="fa fa-file-text-o mr-2 py-1"
            style="font-size: 18px"
            aria-hidden="true"
          ></i> &nbsp;{{ $t('datatable.generateSecondInvoiceButton') }}</v-btn>
      </div>
      <!-- Delivery Invoice: source button is commented out in branchDeliveredOrder.vue for now
      (kept for later use), so addDeliveryInvoiceButton is never passed as true currently. -->
      <div
        v-if="addDeliveryInvoiceButton && $_has_perm(permissions.add_delivery_invoice)"
        class="col-sm-6 col-md-2 text-left"
      >
        <v-btn
          @click="openDeliveryInvoiceModal()"
          style="height: auto; padding-right: 0px; padding-left: 0px"
          depressed
        ><i
            class="fa fa-motorcycle mr-2 py-1"
            style="font-size: 18px"
            aria-hidden="true"
          ></i> &nbsp;{{ $t('datatable.deliveryInvoiceButton') }}</v-btn>
      </div>
      <div
        v-if="!removeWarehouseDeliverButton && $_has_perm(permissions.send_to_warehouse)"
        class="col-sm-6 col-md-3 text-left"
      >
        <v-btn
          @click="openSendToWarehouseModal()"
          style="height: auto; padding-right: 0px; padding-left: 0px"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >send</i>&nbsp;{{ $t('datatable.sendToWarehouseButton') }}</v-btn>
      </div>
      <div
        v-if="addSendToIntShipmentButton && $_has_perm(permissions.send_to_pending_shipment)"
        class="col-sm-6 col-md-3 text-right"
      >
        <v-btn
          @click="openSendToIntShipmentModal()"
          style="height: auto; padding-right: 0px; padding-left: 0px"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >send</i>&nbsp;{{ $t('datatable.sendToPendingShipmentButton') }}</v-btn>
      </div>
      <div
        v-if="addSendAllToIntShipmentButton && $_has_perm(permissions.send_to_pending_shipment)"
        class="col-sm-6 col-md-3 text-right"
      >
        <v-btn
          @click="sendAllToIntShipment()"
          style="height: auto; padding-right: 0px; padding-left: 0px"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >send</i>&nbsp;{{ $t('datatable.sendAllToPendingShipmentButton') }}</v-btn>
      </div>
      <div
        v-if="addSendToIntShipmentButton && $_has_perm(permissions.send_to_shipment)"
        class="col-sm-6 col-md-2 text-right"
      >
        <v-btn
          @click="openSendToIntShipmentModal()"
          style="height: auto; padding-right: 0px; padding-left: 0px"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >send</i>&nbsp;{{ $t('datatable.sendToShipmentButton') }}</v-btn>
      </div>
      <div
        v-if="addSendAllToIntShipmentButton && $_has_perm(permissions.send_to_shipment)"
        class="col-sm-6 col-md-2 text-right"
      >
        <v-btn
          @click="sendAllToIntShipment()"
          style="height: auto; padding-right: 0px; padding-left: 0px"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >send</i>&nbsp;{{ $t('datatable.sendAllToShipmentButton') }}</v-btn>
      </div>
      <div
        v-if="addSendToShipmentByQrcodeButton && $_has_perm(permissions.send_to_shipment_by_qrcode)"
        class="col-sm-6 col-md-2 text-right"
      >
        <v-btn
          @click="openSendToShipmentModal()"
          style="height: auto; padding-right: 0px; padding-left: 0px"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >send</i>&nbsp;{{ $t('datatable.sendToShipmentButton') }}</v-btn>
      </div>
      <div
        v-if="addNewShiponlyButton && $_has_perm(permissions.new_shiponly)"
        class="col-sm-6 col-md-2 text-right"
      >
        <v-btn
          @click="openAddNewShiponlyModal()"
          style="height: auto; padding-right: 0px; padding-left: 0px; background: transparent; border: 1px solid green;color:green;"
          outlined
          flat
        ><v-icon
            icon
            style="color: green"
            class="fa fa-plus fa-lg"
          ></v-icon>&nbsp;{{ $t('datatable.newShiponlyButton') }}</v-btn>
      </div>
      <div
        v-if="addSendToPendingToBranchButton && $_has_perm(permissions.deliver_to_pending_to_branch)"
        class="col-sm-6 col-md-2 text-left"
      >
        <v-btn
          @click="openSendToPendingToBranchModal()"
          style="height: auto; padding-right: 0px; padding-left: 0px"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >send</i>&nbsp;{{ $t('datatable.sendToPendingToBranchButton') }}</v-btn>
      </div>
      <div
        v-if="addSendToBranchButton && $_has_perm(permissions.deliver_to_branch)"
        class="col-sm-6 col-md-2 text-left"
      >
        <v-btn
          @click="openSendToBranchModal()"
          style="height: auto; padding-right: 0px; padding-left: 0px"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >send</i>&nbsp;{{ $t('datatable.sendToBranchButton') }}</v-btn>
      </div>
      <div
        v-if="addSendAllToBranchButton && $_has_perm(permissions.deliver_to_branch)"
        class="col-sm-6 col-md-2 text-left"
      >
        <v-btn
          @click="sendAllToPendingToBranch()"
          style="height: auto; padding-right: 0px; padding-left: 0px"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >send</i>&nbsp;{{ $t('datatable.sendAllToBranchButton') }}</v-btn>
      </div>
      <div
        v-if="addSendToBranchDeliveryButton && $_has_perm(permissions.deliver_to_branch_by_qrcode)"
        class="col-sm-6 col-md-2 text-left"
      >
        <v-btn
          @click="openSendToBranchDeliveryModal()"
          style="height: auto; padding-right: 0px; padding-left: 0px"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >send</i>&nbsp;{{ $t('datatable.sendToBranchDeliveryButton') }}</v-btn>
      </div>
      <div
        v-if="addSendToUserButton && $_has_perm(permissions.send_to_customer)"
        class="col-sm-6 col-md-2 text-left"
      >
        <v-btn
          @click="openSendToUserModal()"
          style="height: auto; padding-right: 0px; padding-left: 0px"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >send</i>&nbsp;{{ $t('datatable.sendToCustomerButton') }}</v-btn>
      </div>

      <div
        v-if="addSendAllToUserButton && $_has_perm(permissions.send_to_customer)"
        class="col-sm-6 col-md-3"
      >
        <v-btn
          @click="sendAllToUser()"
          style="height: auto; padding-right: 0px; padding-left: 0px"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >send</i>&nbsp;{{ $t('datatable.sendAllToCustomerButton') }}</v-btn>
      </div>
      <div
        v-if="addInsertStaffButton && $_has_perm(permissions.add_staff)"
        class="col-xs-6 text-right mobile"
      >
        <v-btn
          @click="openAddStaffModal()"
          style="height: auto"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >person_add</i> &nbsp; {{ $t('datatable.addStaffButton') }}</v-btn>
      </div>
      <div

        class="col-md-3 text-right mobile"
      >

      </div>
      <div
        class="text-right mobile"
        :class="(addSendToIntShipmentButton || addSendAllToIntShipmentButton) && $_has_perm(permissions.send_to_shipment) ? 'col-sm-2 col-md-6' : 'col-sm-3 col-md-6'"
      >
      <v-btn
          v-if="showApproveAllShiponly && $_has_perm(permissions.approve_all_shiponly)"
          @click="loadApproveAllShiponly"
          :loading="approvingMultipleOrder"
          style="height: auto"
          depressed
          color="success"
        ><i
            class="material-icons"
            style="color: white"
          >check_circle</i> &nbsp; {{ $t('datatable.approveAllShiponlyButton') }}</v-btn>
        <v-btn
        v-if="addNewOrderButton && $_has_perm(permissions.add_permission)"
          @click="openAddNewOrderModal(), (checkAlert = false)"
          style="height: auto"
          depressed
        >
          <v-icon
            icon
            style="color: #006b8d"
            class="fa fa-plus fa-lg"
          > </v-icon> &nbsp; {{ $t('datatable.newOrderButton') }}
        </v-btn>
        <v-btn
          v-if="addMultipleOrdersButton && $_has_perm(permissions.add_bulk_permission)"
          @click="openAddMultipleOrdersModal()"
          style="height: auto"
          depressed
          color="teal"
          outline
        >
          <v-icon icon style="color: #00796b" class="fa fa-list-ul fa-lg"> </v-icon>
          &nbsp; {{ $t('datatable.bulkOrdersButton') }}
        </v-btn>
        <v-btn
          v-if="addSendAllToProcessButton && $_has_perm(permissions.send_multiple_to_process)"
          @click="sendAllToProcess()"
          style="height: auto"
          depressed
          color="green"
          outline
        >
          <i class="material-icons" style="color:#2E7D32;">send</i>
          &nbsp; {{ $t('datatable.sendAllToProcessButton') }}
        </v-btn>
      </div>
      <div
        v-if="cashBackButton && $_has_perm(permissions.add_cashback)"
        class="col-sm-6 col-md-3 text-left"
      >
        <v-btn
          @click="openCashBackModal()"
          style="height: auto"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          > monetization_on</i> &nbsp; {{ $t('datatable.cashBackButton') }}</v-btn>
      </div>
      <div
        v-if="addCreatCreditButton && $_has_perm(permissions.add_credit)"
        class="col-sm-6 col-md-3 text-left"
      >
        <v-btn
          @click="openCreatCreditModal()"
          style="height: auto"
          depressed
        >
          <v-icon
            icon
            style="color: #006b8d"
            class="fa fa-plus fa-lg"
          > </v-icon> &nbsp; {{ $t('datatable.addCreditButton') }}
        </v-btn>
      </div>
      <div
        v-if="addWarehouseButton && $_has_perm(permissions.add_warehouse)"
        class="col-sm-6 col-md-3 text-left"
      >
        <v-btn
          @click="openAddWarehouseModal()"
          style="height: auto"
          depressed
        >
          <v-icon
            icon
            style="color: #006b8d"
            class="fa fa-plus fa-lg"
          > </v-icon> &nbsp; {{ $t('datatable.addWarehouseButton') }}
        </v-btn>
      </div>
      <div
        v-if="showCreateCustomerButton && $_has_perm(permissions.add_customer)"
        class="col-sm-6 col-md-6 col-lg-3 text-right mobile"
      >
        <v-btn
          @click="openCreateCustomerModal()"
          style="height: auto"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >person_add</i> &nbsp; {{ $t('datatable.addCustomerButton') }}</v-btn>
      </div>
      <div
        v-if="addGenerateCouponButton && $_has_perm(permissions.add_coupon)"
        class="col-sm-6 col-md-6 text-left"
      >
        <v-btn
          @click="openGenerateCouponModal()"
          style="height: auto"
          depressed
        >
          <!-- <i class="fa fa-credit-card-alt"></i> &nbsp; -->
          {{ $t('datatable.generateCouponButton') }}
        </v-btn>
      </div>
      <div
        v-if="addBankButton && $_has_perm(permissions.add_bank)"
        class="col-xs-6 text-right mobile"
      >
        <v-btn
          @click="openAddBankModal()"
          style="height: auto"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >add</i> &nbsp; {{ $t('datatable.addBankButton') }}</v-btn>
      </div>
      <div
        v-if="addSupplierButton"
        class="col-xs-6 text-right mobile"
      >
        <v-btn
          @click="openAddSupplierModal()"
          style="height: auto"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >add</i> &nbsp; {{ $t('datatable.addSupplierButton') }}</v-btn>
      </div>
      <div
        v-if="addExpenseTypeButton && $_has_perm(permissions.add_expense_type)"
        class="col-xs-6 text-right mobile"
      >
        <v-btn
          @click="openAddExpenseTypeModal()"
          style="height: auto"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >add</i> &nbsp; {{ $t('datatable.addExpenseTypeButton') }}</v-btn>
      </div>
      <div
        v-if="addExpenseButton && $_has_perm(permissions.add_expense)"
        class="col-xs-6 text-right mobile"
      >
        <v-btn
          @click="openAddExpenseModal()"
          style="height: auto"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >add</i> &nbsp; {{ $t('datatable.addNewExpenseButton') }}</v-btn>
      </div>

      <div
        v-if="addNotFoundOrderButton && $_has_perm(permissions.add_not_found_order)"
        class="col-xs-6 text-right mobile"
      >
        <v-btn
          @click="openAddNotFoundOrderModal()"
          style="height: auto"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >add</i> &nbsp; {{ $t('datatable.addNewButton') }}</v-btn>
      </div>

      <div
        v-if="addCityButton && $_has_perm(permissions.add_city)"
        class="col-xs-6 text-right mobile"
      >
        <v-btn
          @click="openAddCityModal()"
          style="height: auto"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >add</i> &nbsp; {{ $t('datatable.addNewCityButton') }}</v-btn>
      </div>
      <div
        v-if="addGovernorateButton && $_has_perm(permissions.add_governorate)"
        class="col-xs-6 text-right mobile"
      >
        <v-btn
          @click="openAddGovernorateModal()"
          style="height: auto"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >add</i> &nbsp; {{ $t('datatable.addGovernorateButton') }}</v-btn>
      </div>

      <div
        v-if="addReasonButton && $_has_perm(permissions.add_reason)"
        class="col-xs-6 text-right mobile"
      >
        <v-btn
          @click="openAddReasonModal()"
          style="height: auto"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >add</i> &nbsp; {{ $t('datatable.addNewReasonButton') }}</v-btn>
      </div>

      <div
        v-if="addAboutButton && $_has_perm(permissions.add_about)"
        class="col-xs-6 text-right mobile"
      >
        <v-btn
          @click="openAddAboutModal()"
          style="height: auto"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >add</i> &nbsp; {{ $t('datatable.addNewAboutAppButton') }}</v-btn>
      </div>

      <div
        v-if="addHelpCenterButton && $_has_perm(permissions.add_help_center)"
        class="col-xs-6 text-right mobile"
      >
        <v-btn
          @click="openAddHelpCenterModal()"
          style="height: auto"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >add</i> &nbsp; {{ $t('datatable.addNewHelpCenterButton') }}</v-btn>
      </div>

      <div
        v-if="addCurrencyRateButton && $_has_perm(permissions.add_currency_rate)"
        class="col-xs-6 text-right mobile"
      >
        <v-btn
          @click="openAddCurrencyRateModal()"
          style="height: auto"
          depressed
        >
          <i
            class="material-icons"
            style="color: #006b8d"
          >
            add
          </i>
          &nbsp; Add New</v-btn>
      </div>

      <div
        v-if="addNewExportOrderButton && $_has_perm(permissions.add_permission)"
        class="col-xs-6 text-right mobile"
      >
        <v-btn
          @click="openAddNewExportOrderModal()"
          style="height: auto"
          depressed
        >
          <i
            class="material-icons"
            style="color: #006b8d"
          >
            add
          </i>
          &nbsp; Add New</v-btn>
      </div>

      <div
        v-if="addRoleButton && $_has_perm(permissions.add_role)"
        class="col-xs-6 text-right mobile"
      >
        <v-btn
          @click="openAddRoleModal()"
          style="height: auto"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >add</i> &nbsp; {{ $t('datatable.addNewRoleButton') }}</v-btn>
      </div>

      <div
        v-if="(addEditSubscriptionPricing && $_has_perm(permissions.add_subscription_pricing)) || (deleteAllSubscriptionPricingButton && $_has_perm(permissions.delete_subscription_pricing))"
        class="col-xs-6 text-right mobile"
        style="display: flex; justify-content: flex-end; gap: 10px"
      >
        <v-btn
          v-if="deleteAllSubscriptionPricingButton && $_has_perm(permissions.delete_subscription_pricing)"
          @click="deleteAllSubscriptionPricing()"
          style="height: auto"
          depressed
          color="error"
        ><i
            class="material-icons"
            style="color: white"
          >delete</i> &nbsp; {{ $t('datatable.deleteSelectedSubscriptionButton') }}</v-btn>
          <v-btn
          v-if="addEditSubscriptionPricing && $_has_perm(permissions.add_subscription_pricing)"
          @click="openAddEditSubscriptionPricingModal()"
          style="height: auto"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >add</i> &nbsp; {{ $t('datatable.addNewCustomerSubscriptionButton') }}</v-btn>
      </div>

      <div
        v-if="permanentlyDeleteAllCanceledOrder && $_has_perm(permissions.permanently_delete_canceled_order)"
        class="col-xs-6 text-right mobile"
        style="display: flex; justify-content: flex-end; gap: 10px"
      >
        <!-- Soft-delete "Delete Selected Orders" button hidden in favor of permanent
             delete. Commented out (not removed) for later use — restore by moving the
             v-if below back onto this button and reverting the wrapper div's v-if to
             `deleteAllCanceledOrderButton && $_has_perm(permissions.delete_canceled_order)`.
        <v-btn
          v-if="deleteAllCanceledOrderButton && $_has_perm(permissions.delete_canceled_order)"
          @click="deleteAllCanceledOrder()"
          style="height: auto"
          depressed
          color="error"
        ><i
            class="material-icons"
            style="color: white"
          >delete</i> &nbsp; Delete Selected Orders</v-btn>
        -->
        <v-btn
          @click="permanentlyDeleteAllCanceledOrder()"
          style="height: auto"
          depressed
          color="error"
        ><i
            class="material-icons"
            style="color: white"
          >delete_forever</i> &nbsp; {{ $t('datatable.permanentlyDeleteSelectedOrdersButton') }}</v-btn>
      </div>

      <div
        v-if="(addEditCustomerSubscription && $_has_perm(permissions.add_customer_subscription)) || (deleteAllSubscriptionButton && $_has_perm(permissions.delete_customer_subscription))"
        class="col-xs-6 text-right mobile"
        style="display: flex; justify-content: flex-end; gap: 10px"
      >
        <v-btn
          v-if="deleteAllSubscriptionButton && $_has_perm(permissions.delete_customer_subscription)"
          @click="deleteAllCustomerSubscription()"
          style="height: auto"
          depressed
          color="error"
        ><i
            class="material-icons"
            style="color: white"
          >delete</i> &nbsp; {{ $t('datatable.deleteSelectedSubscriptionButton') }}</v-btn>
          <v-btn
          v-if="addEditCustomerSubscription && $_has_perm(permissions.add_customer_subscription)"
          @click="openAddEditCustomerSubscriptionModal()"
          style="height: auto"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >add</i> &nbsp; {{ $t('datatable.addNewCustomerSubscriptionButton') }}</v-btn>
      </div>

      <div
        v-if="addBranchButton && $_has_perm(permissions.add_branch)"
        class="col-xs-6 text-right mobile"
      >
        <v-btn
          @click="openAddBranchModal()"
          style="height: auto"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >add</i> &nbsp; {{ $t('datatable.addNewBranchButton') }}</v-btn>
      </div>

      <div
        v-if="addMoneyButton && $_has_perm(permissions.add_money)"
        class="col-xs-6 text-right mobile"
      >
        <v-btn
          @click="openAddMoneyModal()"
          style="height: auto"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >add</i> &nbsp; {{ addMoneyButtonLabel || $t('datatable.addMoneyButtonDefault') }}</v-btn>
      </div>
      <div
        v-if="addMoneyTransferButton && $_has_perm(permissions.add_money_transfer)"
        class="col-xs-6 text-right mobile"
      >
        <v-btn
          @click="openAddMoneyTransferModal()"
          style="height: auto"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >add</i> &nbsp; {{ $t('datatable.transferMoneyButton') }}</v-btn>
      </div>
      <div
        v-if="showPurchaseAll && $_has_perm(permissions.purchase_permission)"
        class="col-xs-6 text-right mobile"
      >
        <v-btn
          @click="confirmPurchaseAll()"
          style="height: auto"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >add_shopping_cart</i> &nbsp;
          {{ $t('orders.sortByPurchase') }}</v-btn>
      </div>
      <div
        v-if="showVerifyAll && $_has_perm(permissions.verify_permission)"
        class="col-xs-6 text-right mobile"
      >
        <v-btn
          @click="confirmVerifyAll()"
          style="height: auto"
          depressed
          small
        ><i
            class="material-icons"
            style="color: #2e7d32; font-size: 18px"
          >check_circle</i>&nbsp;{{ $t('signup.verifyButton') }}</v-btn>
      </div>
      <div
        v-if="showApproveAll && $_has_perm(permissions.approve_all_permission)"
        class="col-xs-6 text-right mobile"
      >
        <v-btn
          @click="approvingMultipleOrder()"
          :loading="loadApproveAll"
          style="height: auto"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >check_circle</i> &nbsp; {{ $t('orders.approveTooltip') }}</v-btn>
      </div>
      <div
        v-if="addExchangeRateButton && $_has_perm(permissions.add_exchange_rate)"
        class="col-xs-6 text-right mobile"
      >
        <v-btn
          @click="openAddExchangeRateModal()"
          style="height: auto"
          depressed
        ><i
            class="material-icons"
            style="color: #006b8d"
          >add</i> &nbsp; {{ $t('datatable.addExchangeRateButton') }}</v-btn>
      </div>
      <div
        v-if="showAddOrderDeliveryButton"
        class="col-sm-6 col-md-6 text-right mobile add-order-delivery-col"
      >
        <v-btn
          style="height: auto"
          depressed
          @click="openAddOrderDeliveryModal()"
        >
          <v-icon
            icon
            style="color: #006b8d"
            class="fa fa-plus fa-lg mr-2"
          > </v-icon>
          {{ $t('datatable.requestDeliveryButton') }}
        </v-btn>
      </div>
    </div>

    <v-layout
      wrap
      class="mx-2"
      :class="{ 'filters-no-wrap': noWrapFilters }"
    >
      <v-flex
        v-show="showCollapsibleFilters"
        ref="searchFieldWrapper"
        class="filter-field-wide"
        style="align-self: flex-end;"
      >
        <v-text-field
          append-icon="search"
          :append-icon-cb="() => searchMe(tableData.search)"
          id="search-field"
          :label="$t('common.search')"
          hide-details
          autocomplete="off"
          v-model="tableData.search"
          @focus="showCustomerSuggestions = true"
          @blur="onSearchBlur"
          @keyup.enter="searchMe(tableData.search)"
        >
        </v-text-field>

        <ul
          v-if="showSuggestionsDropdown"
          ref="customerSuggestionsDropdown"
          class="customer-search-suggestions-list"
          :style="customerSuggestionDropdownStyle"
        >
          <li
            v-for="customer in customerSearchMatches"
            :key="customer.user_id"
            class="customer-search-suggestion-item"
            @mousedown.prevent="selectCustomerSuggestion(customer)"
          >
            {{ formatCustomerSuggestion(customer) }}
          </li>
        </ul>
      </v-flex>

      <v-flex
        v-if="warehouseFilterItems && warehouseFilterItems.length > 0 && showCollapsibleFilters"
        class="filter-field px-2"
        style="align-self: flex-end;"
      >
        <v-select
          :items="warehouseFilterItemsWithSelectAll"
          v-model="warehouseFilterVal"
          :label="$t('columns.warehouse')"
          multiple
          clearable
          hide-details
          item-text="text"
          item-value="value"
        >
          <template slot="selection" slot-scope="{ index }">
            <span v-if="index === 0">{{ $t('common.selectedCountLabel', { count: warehouseFilterVal.length }) }}</span>
          </template>
        </v-select>
      </v-flex>

      <v-flex
        v-if="statusFilterItems && statusFilterItems.length > 0 && showCollapsibleFilters"
        class="filter-field px-2"
        style="align-self: flex-end;"
      >
        <v-select
          :items="statusFilterItemsWithSelectAll"
          v-model="statusFilterVal"
          :label="$t('columns.status')"
          multiple
          clearable
          hide-details
          item-text="text"
          item-value="value"
        >
          <template slot="selection" slot-scope="{ index }">
            <span v-if="index === 0">{{ $t('common.selectedCountLabel', { count: statusFilterVal.length }) }}</span>
          </template>
        </v-select>
      </v-flex>

      <v-flex
        v-if="paymentFilterItems && paymentFilterItems.length > 0 && showCollapsibleFilters"
        class="filter-field px-2"
        style="align-self: flex-end;"
      >
        <v-select
          :items="paymentFilterItemsWithSelectAll"
          v-model="paymentFilterVal"
          :label="$t('columns.payment')"
          multiple
          clearable
          hide-details
          item-text="text"
          item-value="value"
        >
          <template slot="selection" slot-scope="{ index }">
            <span v-if="index === 0">{{ $t('common.selectedCountLabel', { count: paymentFilterVal.length }) }}</span>
          </template>
        </v-select>
      </v-flex>

      <v-flex
        v-if="showReceivedFilter && showCollapsibleFilters"
        class="filter-field px-2"
        style="align-self: flex-end;"
      >
        <v-select
          :items="receivedFilterItemsOverride || receivedFilterItems"
          v-model="receivedFilterVal"
          :label="$t('finance.received')"
          multiple
          clearable
          hide-details
          item-text="text"
          item-value="value"
        >
          <template slot="selection" slot-scope="{ index }">
            <span v-if="index === 0">{{ $t('common.selectedCountLabel', { count: receivedFilterVal.length }) }}</span>
          </template>
        </v-select>
      </v-flex>

      <v-flex
        v-if="addSelect"
        class="filter-field px-2"
        style="align-self: flex-end;"
      >
        <v-select
          :items="dates"
          v-model="dateValue"
          @input="prepareToExport()"
          :label="$t('common.select')"
          single-line
          hide-details
        ></v-select>
      </v-flex>

      <slot name="custom-filter-before-date" />

      <v-flex
        v-show="!addSelect && !removeFromToDate && showCollapsibleFilters"
        class="filter-field-auto filter-label-gap px-2"
        style="align-self: flex-end;"
      >
        <p>{{ $t('common.filterColon') }}</p>
      </v-flex>

      <v-flex
        v-show="!removeFromToDate && showCollapsibleFilters"
        class="filter-field px-2"
        style="align-self: flex-end;"
      >
        <date-picker
          style="margin-top: 2px; border-bottom-color: #919191"
          :date="startTime"
          :option="option"
          class="form-control"
        ></date-picker>
      </v-flex>

      <v-flex
        v-show="!removeFromToDate && showCollapsibleFilters"
        class="filter-field px-2"
        style="align-self: flex-end;"
      >
        <date-picker
          style="margin-top: 2px; border-bottom-color: #919191"
          :date="startTime1"
          :option="option1"
          class="form-control"
        ></date-picker>
      </v-flex>

      <v-flex
        v-show="!removeFromToDate && showCollapsibleFilters"
        class="filter-field-auto px-2"
        style="align-self: flex-end;"
      >
        <a
          v-if="!filterApplied"
          :tooltip="$t('datatable.applyFilterTooltip')"
          @click="checkDates()"
        ><i class="fa fa-filter fa-2x"></i></a>

        <a
          v-if="filterApplied"
          :tooltip="$t('datatable.cancelFilterTooltip')"
          @click="
              resetGetResults2()
              filterApplied = false
              resetDatePickerDefaults()
            "
          style="color: orange"
        >
          <span class="fa-stack">
            <i class="fa fa-filter fa-stack-2x"></i>
            <i
              class="fa fa-times fa-stack-1x clear-filter-icon"
            ></i>
          </span>
        </a>
      </v-flex>

      <v-flex
        v-if="!intShipment && showCollapsibleFilters"
        class="filter-field-auto px-2"
        style="align-self: flex-end;"
      >
        <label
          v-if="!filterMade"
          style="white-space: nowrap;"
        >
          {{ $t('common.showResultLabel') }}
          <span v-show="pagination.from && pagination.to">{{ pagination.from || 0 }}-{{ pagination.to }} {{ $t('common.of') }} {{ pagination.total }} </span>{{ $t('common.resultLabel') }}
        </label>
        <label
          v-else
          style="white-space: nowrap;"
        >{{ $t('common.totalResultLabel', { count: totalResult }) }}</label>
      </v-flex>

      <v-flex
        v-if="!intShipment && !filterMade && showCollapsibleFilters"
        class="filter-field-narrow px-2"
        style="align-self: flex-end;"
      >
        <v-select
          :items="options"
          item-value="value"
          v-model="val"
          @input="getPerPage()"
          :label="$t('common.select')"
          single-line
          hide-details
        ></v-select>
      </v-flex>

      <v-flex
        v-if="!intShipment && !hideSelectingColumn && showCollapsibleFilters"
        class="filter-field-wide px-2"
        style="align-self: flex-end;"
      >
        <v-select
          :items="columns"
          v-model="colVal"
          @input="prepareToShowHideColumn(colVal)"
          multiple
          hide-details
          :label="$t('datatable.showHideColumnsLabel')"
        >
          <template slot="selection" slot-scope="{ index }">
            <span v-if="index === 0">{{ $t('common.selectedCountLabel', { count: colVal.length }) }}</span>
          </template>
        </v-select>
      </v-flex>

      <!-- <v-flex
        v-if="loggedInUserData.is_staff && !hideBranch"
        sm12
        md6
        lg5
        xl4
        class="px-3"
      >
        <div class="row">
          <div class="col-sm-10">
            <v-select
              :items="branchesList"
              v-model="branches"
              multiple
              autocomplete
              hide-details
              chips
              deletable-chips
              :label="$t('columns.branch')"
              clearable
            >
            </v-select>
          </div>
          <div class="col-sm-2 pt-4">
            <button
              class="py-1 px-3 white--text filter-branch-btn"
              :class="branches.length > 0 ? 'pointer primary' : 'grey lighten-1 not-allowed'"
              style="border-radius: 4px"
              :disabled="branches.length == 0"
              @click="filterBranch(branches)"
            >
              Done
            </button>
          </div>
        </div>
      </v-flex> -->

      <slot name="custom-filter-start" />

      <v-flex
        v-if="platformFilterItems && platformFilterItems.length > 0 && showCollapsibleFilters"
        class="filter-field px-3"
        style="align-self: flex-end;"
      >
        <v-select
          :items="platformFilterItemsWithSelectAll"
          v-model="platformFilterVal"
          :label="$t('columns.platform')"
          multiple
          clearable
          hide-details
          single-line
          item-text="text"
          item-value="value"
        >
          <template slot="selection" slot-scope="{ index }">
            <span v-if="index === 0">{{ $t('common.selectedCountLabel', { count: platformFilterVal.length }) }}</span>
          </template>
        </v-select>
      </v-flex>

      <slot name="custom-filter" />

      <v-flex
        v-if="intShipment"
        sm12
        md4
        style="padding-top: 30px"
      >
        <v-layout wrap>
          <v-flex
            sm5
            md5
          >
            <label
              v-if="!filterMade"
              class="results-count-label"
            >
              {{ $t('common.showResultLabel') }}
              <span v-show="pagination.from && pagination.to">{{ pagination.from || 0 }} - {{ pagination.to }} {{ $t('common.of') }}
                {{ pagination.total }}
              </span>
              &nbsp;&nbsp;
            </label>
            <label
              v-else
              class="results-count-label"
            >{{ $t('common.totalResultLabel', { count: totalResult }) }}</label>
          </v-flex>

          <v-flex
            sm2
            md2
            v-if="!filterMade"
          >
            <v-select
              :items="options"
              v-model="val"
              @input="getPerPage()"
              :label="$t('common.select')"
              single-line
              hide-details
            ></v-select>
          </v-flex>

          <v-flex
            sm1
            md1
            v-if="!filterMade"
          >
            <v-select
              :items="warehouses"
              v-model="ware"
              @input="prepareGetByWarehouse()"
              :label="$t('common.select')"
              single-line
              hide-details
              :hint="wareError === true ? $t('datatable.pleaseSelectWarehouseHint') : ''"
            ></v-select>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import myDatepicker from 'vue-datepicker'
import swal from 'sweetalert'
import Axios from 'axios'
import { withSelectAllOption, expandSelectAll } from '../mixins/filterSelectAll'

export default {
  created() {
    this.getLoggedInUser()
    this.getConnectedBranches()
    this.setDefaultPerPage()
    let hasSavedCols = false
    if (this.storageKey) {
      const saved = localStorage.getItem(this.storageKey)
      if (saved) {
        this.colVal = JSON.parse(saved)
        hasSavedCols = true
      }
    }
    if (!hasSavedCols && this.defaultHideCol && this.defaultHideCol.length > 0) {
      this.colVal = this.defaultHideCol
    }
    if (this.enableCustomerSearchSuggestions) {
      this.fetchCustomerSearchList()
    }
  },

  beforeDestroy() {
    if (this.customerSuggestionsBlurTimeout) clearTimeout(this.customerSuggestionsBlurTimeout)
    window.removeEventListener('scroll', this.updateCustomerDropdownPosition, true)
    window.removeEventListener('resize', this.updateCustomerDropdownPosition)
    const dropdown = this.$refs.customerSuggestionsDropdown
    if (dropdown && dropdown.parentNode) {
      dropdown.parentNode.removeChild(dropdown)
    }
  },

  mounted() {
    if (this.storageKey && this.colVal.length > 0 && this.showHideColumn) {
      setTimeout(() => {
        this.showHideColumn([], this.colVal)
      }, 500)
    }
  },

  components: {
    'date-picker': myDatepicker
  },

  props: [
    'hideReloadButton',
    'collapsibleFilters',
    'filtersVisible',
    'permissions',
    'showApproveAllShiponly',
    'showApproveAll',
    'loadApproveAllShiponly',
    'approvingMultipleOrder',
    'showPurchaseAll',
    'confirmPurchaseAll',
    'showChangeStatusAll',
    'confirmChangeStatusAll',
    'addCustomerDeliverySummaryButton',
    'openCustomerDeliverySummaryModal',
    'addUnclearButton',
    'confirmUnclearAll',
    'showVerifyAll',
    'confirmVerifyAll',
    'showFastPaymentAll',
    'confirmFastPaymentAll',
    'showReceiveAll',
    'confirmReceiveAll',
    'showUnreceiveAll',
    'confirmUnreceiveAll',
    'addReceivePrintButton',
    'receivePrintList',
    'showOutOfficeAll',
    'confirmOutOfficeAll',
    'addMergePrintButton',
    'mergePrintList',
    'filterMade',
    'removeFromToDate',
    'totalResult',
    'hideSelectingColumn',
    'showHideColumn',
    'defaultHideCol',
    'resultsVersion',
    'columns',
    'getDependDate',
    'addSelect',
    'addBankButton',
    'openAddBankModal',
    'addPrepareToPrintButton',
    'prepareToPrint',
    'removeWarehouseDeliverButton',
    'tableData',
    'resetGetResults',
    'resetGetResults2',
    'searchMe',
    'pagination',
    'removeAddButton',
    'perPageFix',
    'filterTable',
    'openSendToWarehouseModal',
    'addInsertStaffButton',
    'openAddStaffModal',
    'deleteAllSubscriptionPricingButton',
    'deleteAllSubscriptionPricing',
    'deleteAllCanceledOrderButton',
    'deleteAllCanceledOrder',
    'permanentlyDeleteAllCanceledOrder',
    'addEditSubscriptionPricing',
    'deleteAllSubscriptionButton',
    'deleteAllCustomerSubscription',
    'addEditCustomerSubscription',
    'openAddEditSubscriptionPricingModal',
    'openAddEditCustomerSubscriptionModal',
    'openAddWarehouseModal',
    'openAddNewOrderModal',
    'addNewOrderButton',
    'addMultipleOrdersButton',
    'openAddMultipleOrdersModal',
    'addSendAllToProcessButton',
    'sendAllToProcess',
    'addGovernorateButton',
    'openAddGovernorateModal',
    'checkAlert',
    'showCreateCustomerButton',
    'openCreateCustomerModal',
    'addCreatCreditButton',
    'addSecondOrderInvoiceButton',
    'openSecondOrderInvoiceModal',
    'openCreatCreditModal',
    'addQrCodeGenerateButton',
    'showAddExportOrderButton',
    'handleAddExportOrder',
    'openGenerateQrCodeModal',
    'addSendToIntShipmentButton',
    'openSendToIntShipmentModal',
    'addSendAllToIntShipmentButton',
    'sendAllToIntShipment',
    'addSendToShipmentByQrcodeButton',
    'openSendToShipmentModal',
    'addSendToBranchButton',
    'addSendToPendingToBranchButton',
    'openSendToBranchModal',
    'addSendToUserButton',
    'openSendToUserModal',
    'addExportButton',
    'addWarehouseButton',
    'sendToExport',
    'addGenerateCouponButton',
    'openGenerateCouponModal',
    'cashBackButton',
    'openCashBackModal',
    'intShipment',
    'addNewShiponlyButton',
    'openAddNewShiponlyModal',
    'getByWarehouse',
    'addExchangeRateButton',
    'openAddExchangeRateModal',
    'addSupplierButton',
    'openAddSupplierModal',
    'addOrderInvoiceButton',
    'openOrderInvoiceModal',
    'showAddOrderDeliveryButton',
    'openAddOrderDeliveryModal',
    'showAttachToDeliveryButton',
    'attachToDelivery',
    'addSendAllToUserButton',
    'sendAllToUser',
    'addExpenseTypeButton',
    'openAddExpenseTypeModal',
    'addExpenseButton',
    'openAddExpenseModal',
    'addRoleButton',
    'openAddRoleModal',
    'addBranchButton',
    'openAddBranchModal',
    'addMoneyTransferButton',
    'openAddMoneyTransferModal',
    'addMoneyButton',
    'addMoneyButtonLabel',
    'openAddMoneyModal',
    'hideBranch',
    'addDeliveryInvoiceButton',
    'openDeliveryInvoiceModal',
    'openSendToPendingToBranchModal',
    'addSendAllToBranchButton',
    'sendAllToPendingToBranch',
    'addSendToBranchDeliveryButton',
    'openSendToBranchDeliveryModal',
    'addCityButton',
    'addReasonButton',
    'addAboutButton',
    'openAddAboutModal',
    'addHelpCenterButton',
    'openAddHelpCenterModal',
    'openAddCityModal',
    'openAddReasonModal',
    'addNotFoundOrderButton',
    'openAddNotFoundOrderModal',
    'addCurrencyRateButton',
    'openAddCurrencyRateModal',
    'addNewExportOrderButton',
    'openAddNewExportOrderModal',
    'warehouseFilterItems',
    'warehouseFilterChange',
    'statusFilterItems',
    'statusFilterChange',
    'defaultStatusFilterValues',
    'showReceivedFilter',
    'receivedFilterChange',
    'receivedFilterItemsOverride',
    'paymentFilterItems',
    'paymentFilterChange',
    'platformFilterItems',
    'platformFilterChange',
    'storageKey',
    'enableCustomerSearchSuggestions',
    'noWrapFilters',
    'defaultFromDate',
    'defaultToDate'
  ],

  data() {
    return {
      colVal: [],
      prevColVal: [],
      branchesList: [],
      branches: [],
      loggedInUserData: {},
      customerSearchList: [],
      showCustomerSuggestions: false,
      customerSuggestionsBlurTimeout: null,
      customerSuggestionDropdownStyle: {},
      options: [
        { text: '10', value: 10 },
        { text: '25', value: 25 },
        { text: '50', value: 50 },
        { text: '100', value: 100 },
        { text: '150', value: 150 },
        { text: '200', value: 200 },
        { text: '250', value: 250 },
        { text: '300', value: 300 },
        { text: '350', value: 350 },
        { text: '400', value: 400 },
        { text: '450', value: 450 },
        { text: '500', value: 500 }
      ],
      warehouses: [
        { text: this.$t('common.select'), value: 'Select' },
        { text: this.$t('datatable.usaOption'), value: 1 },
        // { text: 'Turkey', value: 2 },
        { text: this.$t('datatable.chinaOption'), value: 3 },
        { text: this.$t('datatable.uaeOption'), value: 4 }
      ],
      dates: [
        { text: this.$t('datatable.chooseOption'), value: '' },
        { text: this.$t('datatable.orderOption'), value: 'orders.created_at' },
        { text: this.$t('columns.confirmDate'), value: 'orders.confirm_date' },
        { text: this.$t('orders.sortByPurchase'), value: 'orders.purchase_date' }
      ],
      val: 50,
      warehouseFilterVal: [],
      // Seeded from the optional defaultStatusFilterValues prop (e.g. orderDeliveries.vue
      // defaulting to Pending/Post/Sent) so the checkboxes show as pre-selected on load,
      // matching the caller's initial tableData.statuses without an extra getResults() call
      // (unlike the statusFilterVal watcher below, an initial data() value doesn't fire it).
      statusFilterVal: this.defaultStatusFilterValues || [],
      receivedFilterVal: [],
      receivedFilterItems: [
        { text: this.$t('finance.received'), value: 'received' },
        { text: this.$t('datatable.partialReceivedOption'), value: 'partial_received' },
        { text: this.$t('finance.notReceived'), value: 'not_received' }
      ],
      paymentFilterVal: [],
      platformFilterVal: [],
      dateValue: '',
      ware: 'Select',
      filterApplied: false,
      wareError: false,
      // Seeded from the optional defaultFromDate/defaultToDate props (e.g. orderInvoices.vue
      // suggesting "2026-01-01" -> yesterday) purely so the fields aren't blank on load - this
      // is display only and is NOT applied to tableData.from_date/to_date, so no date filter
      // is actually sent until the user explicitly clicks the "Apply Filter" icon.
      startTime: {
        time: this.defaultFromDate || ''
      },
      startTime1: {
        time: this.defaultToDate || ''
      },
      option: {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December'
        ],
        format: 'YYYY-MM-DD',
        placeholder: this.$t('columns.fromDate'),
        inputStyle: {
          display: 'inline-block',
          padding: '6px',
          'line-height': '22px',
          'font-size': '16px',
          color: '#2d2d2d',
          width: '100%'
        },
        color: {
          header: '#5a5bcc',
          headerText: '#f4fff5'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      option1: {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December'
        ],
        format: 'YYYY-MM-DD',
        placeholder: this.$t('columns.toDate'),
        inputStyle: {
          display: 'inline-block',
          padding: '6px',
          'line-height': '22px',
          'font-size': '16px',
          color: '#2d2d2d',
          width: '100%'
        },
        color: {
          header: '#5a5bcc',
          headerText: '#f4fff5'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      timeoption: {
        type: 'min',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December'
        ],
        format: 'YYYY-MM-DD HH:mm'
      },
      multiOption: {
        type: 'multi-day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December'
        ],
        format: 'YYYY-MM-DD HH:mm'
      },
      limit: [
        {
          type: 'weekday',
          available: [1, 2, 3, 4, 5]
        },
        {
          type: 'fromto',
          from: '2016-02-01',
          to: '2016-02-20'
        }
      ]
    }
  },

  computed: {
    // Opt-in collapsible filters: when a consumer doesn't pass collapsibleFilters at all
    // (every existing page), this is always true so the date-range/per-page/column-visibility
    // controls below render exactly as before -- only a page that explicitly passes
    // collapsibleFilters + filtersVisible gets the show/hide behavior.
    showCollapsibleFilters() {
      return !this.collapsibleFilters || this.filtersVisible
    },

    warehouseFilterItemsWithSelectAll() {
      return withSelectAllOption(this.warehouseFilterItems)
    },

    statusFilterItemsWithSelectAll() {
      return withSelectAllOption(this.statusFilterItems)
    },

    paymentFilterItemsWithSelectAll() {
      return withSelectAllOption(this.paymentFilterItems)
    },

    platformFilterItemsWithSelectAll() {
      return withSelectAllOption(this.platformFilterItems)
    },

    customerSearchMatches() {
      if (!this.enableCustomerSearchSuggestions) return []
      const query = String((this.tableData && this.tableData.search) || '').trim().toLowerCase()
      if (!query) return []
      const normalizedQuery = query.replace(/\D/g, '')
      return this.customerSearchList.filter(customer => {
        const name = (customer.full_name || '').toLowerCase()
        const phone1 = String(customer.phone_number || '')
        const phone2 = String(customer.phone_number_2 || '')
        if (name.includes(query)) return true
        if (phone1.toLowerCase().includes(query) || phone2.toLowerCase().includes(query)) return true
        if (normalizedQuery && (phone1.replace(/\D/g, '').includes(normalizedQuery) || phone2.replace(/\D/g, '').includes(normalizedQuery))) return true
        return false
      }).slice(0, 8)
    },

    showSuggestionsDropdown() {
      return !!(this.enableCustomerSearchSuggestions && this.showCustomerSuggestions && this.customerSearchMatches.length)
    }
  },

  watch: {
    showSuggestionsDropdown(open) {
      if (open) {
        this.$nextTick(() => {
          this.attachCustomerDropdownToBody()
          this.updateCustomerDropdownPosition()
          window.addEventListener('scroll', this.updateCustomerDropdownPosition, true)
          window.addEventListener('resize', this.updateCustomerDropdownPosition)
        })
      } else {
        window.removeEventListener('scroll', this.updateCustomerDropdownPosition, true)
        window.removeEventListener('resize', this.updateCustomerDropdownPosition)
      }
    },

    warehouseFilterVal(newVal) {
      const expanded = expandSelectAll(newVal, (this.warehouseFilterItems || []).map(i => i.value))
      if (expanded !== newVal) {
        this.warehouseFilterVal = expanded
        return
      }
      if (this.warehouseFilterChange) {
        this.warehouseFilterChange(newVal || [])
      }
    },

    'tableData.warehouse_id_fk'(newVal) {
      if (!newVal) {
        this.warehouseFilterVal = []
      }
    },

    statusFilterVal(newVal) {
      const expanded = expandSelectAll(newVal, (this.statusFilterItems || []).map(i => i.value))
      if (expanded !== newVal) {
        this.statusFilterVal = expanded
        return
      }
      if (this.statusFilterChange) {
        this.statusFilterChange(newVal || [])
      }
    },

    'tableData.status_filter'(newVal) {
      if (!newVal) {
        this.statusFilterVal = []
      }
    },

    receivedFilterVal(newVal) {
      if (this.receivedFilterChange) {
        this.receivedFilterChange(newVal || [])
      }
    },

    'tableData.received_filter'(newVal) {
      if (!newVal) {
        this.receivedFilterVal = []
      }
    },

    paymentFilterVal(newVal) {
      const expanded = expandSelectAll(newVal, (this.paymentFilterItems || []).map(i => i.value))
      if (expanded !== newVal) {
        this.paymentFilterVal = expanded
        return
      }
      if (this.paymentFilterChange) {
        this.paymentFilterChange(newVal || [])
      }
    },

    // Missing this was the reload-table bug: warehouse/status/received all clear their local
    // *FilterVal (and thus the v-select's visible selection) when the parent's resetGetResults()
    // blanks the matching tableData.*_filter, but payment never had the equivalent watcher — the
    // parent-side reset correctly cleared tableData.payment_filter (so the next request dropped
    // the filter), yet the dropdown itself kept showing the old selection until manually touched.
    'tableData.payment_filter'(newVal) {
      if (!newVal) {
        this.paymentFilterVal = []
      }
    },

    platformFilterVal(newVal) {
      const expanded = expandSelectAll(newVal, (this.platformFilterItems || []).map(i => i.value))
      if (expanded !== newVal) {
        this.platformFilterVal = expanded
        return
      }
      if (this.platformFilterChange) {
        this.platformFilterChange(newVal || [])
      }
    },

    colVal(newVal, oldVal) {
      this.prevColVal = oldVal
      if (this.storageKey) {
        localStorage.setItem(this.storageKey, JSON.stringify(newVal))
      }
    },

    branches(newVal) {
      if (newVal.length === 0) {
        this.$emit('branch-edit', newVal)
      }
    },

    defaultHideCol(newVal) {
      this.colVal = newVal
      this.showHideColumn([], this.colVal)
    },

    // The hide/show toggle in showHideColumn() is applied via a one-time,
    // imperative jQuery .toggle() on whatever <td>/<th> DOM nodes exist at
    // the moment it runs — it isn't a persistent CSS rule. Whenever the
    // parent's table data reloads (filter, reload, pagination), Vue's v-for
    // recreates the <tbody> rows from scratch, so those new cells never
    // inherit the earlier hidden state. Re-apply it every time the parent
    // bumps resultsVersion after a fresh getResults() so hidden columns
    // stay hidden across reloads, not just on first mount.
    resultsVersion() {
      if (this.storageKey && this.colVal.length > 0 && this.showHideColumn) {
        this.$nextTick(() => {
          this.showHideColumn([], this.colVal)
        })
      }
    }
  },

  methods: {
    // "Reload Table" and "Cancel Filter" used to blank the date pickers outright. Restore the
    // caller-provided defaultFromDate/defaultToDate suggestion instead (falling back to '' when
    // none was given) so the fields don't go empty after those actions.
    resetDatePickerDefaults() {
      this.startTime.time = this.defaultFromDate || ''
      this.startTime1.time = this.defaultToDate || ''
    },

    setDefaultPerPage() {
      if (this.loggedInUserData && !this.loggedInUserData.is_staff) {
        this.val = 50
      } else {
        this.val = 10
      }
      // Update tableData to match
      if (this.tableData) {
        this.tableData.per_page = this.val
      }
    },

    filterBranch(branches) {
      let filterBtn = document.querySelector('.filter-branch-btn')
      filterBtn.classList.add('animate-filter-branch-btn')
      this.$emit('branch-edit', branches)
      setTimeout(() => {
        filterBtn.classList.remove('animate-filter-branch-btn')
      }, 400)
    },

    prepareToShowHideColumn(currentColVal) {
      setTimeout(() => {
        this.showHideColumn(this.prevColVal, currentColVal)
      }, 500)
    },

    prepareToExport() {
      if (this.dateValue === '') {
        this.dateValue = 'orders.created_at'
      } else {
        this.getDependDate(this.dateValue)
      }
    },

    getPerPage() {
      this.tableData.per_page = this.val
      this.perPageFix(this.tableData.per_page)
    },

    prepareGetByWarehouse() {
      if (this.ware === 'Select') {
        this.wareError = true
      } else {
        this.wareError = false
        this.tableData.warehouse = this.ware
        this.getByWarehouse(this.tableData.warehouse)
      }
    },

    getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'))
    },

    getConnectedBranches() {
      this.branchesList = []
      let token = localStorage.getItem('access_token')
      Axios
        .get('api/branch/connected-branch-list', { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let result = response.data
          result.forEach(r => {
            this.branchesList.push({ text: r.branch_name, value: r.branch_id })
          })
        })
    },

    checkDates() {
      if (this.startTime.time === '' || this.startTime1.time === '') {
        swal('', this.$t('datatable.pleaseSelectBothDatesError'), 'warning')
      } else {
        this.filterTable(this.startTime.time, this.startTime1.time, this.dateValue)
        this.filterApplied = true
      }
    },

    fetchCustomerSearchList() {
      const token = localStorage.getItem('access_token')
      Axios.get('api/get-customer-to-select', { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          this.customerSearchList = (response.data.data || []).map(c => ({
            user_id: c.user_id,
            full_name: c.full_name,
            phone_number: c.phone_number || '',
            phone_number_2: c.phone_number_2 || ''
          }))
        })
        .catch(() => { this.customerSearchList = [] })
    },

    formatCustomerSuggestion(customer) {
      const phones = [customer.phone_number, customer.phone_number_2].filter(Boolean).join(' / ')
      return phones ? customer.full_name + ' - Tel: ' + phones : customer.full_name
    },

    selectCustomerSuggestion(customer) {
      this.tableData.search = customer.full_name
      this.showCustomerSuggestions = false
      this.searchMe(this.tableData.search)
    },

    onSearchBlur() {
      // mousedown.prevent on each suggestion is the primary defense against blur
      // firing before the click registers; this timeout is just a fallback.
      this.customerSuggestionsBlurTimeout = setTimeout(() => {
        this.showCustomerSuggestions = false
      }, 150)
    },

    attachCustomerDropdownToBody() {
      const dropdown = this.$refs.customerSuggestionsDropdown
      if (dropdown && dropdown.parentNode !== document.body) {
        document.body.appendChild(dropdown)
      }
    },

    updateCustomerDropdownPosition() {
      const dropdown = this.$refs.customerSuggestionsDropdown
      const wrapper = this.$refs.searchFieldWrapper
      const wrapperEl = wrapper && (wrapper.$el || wrapper)
      if (!dropdown || !wrapperEl) return
      const rect = wrapperEl.getBoundingClientRect()
      this.customerSuggestionDropdownStyle = {
        position: 'fixed',
        top: rect.bottom + 'px',
        left: rect.left + 'px',
        width: rect.width + 'px',
        zIndex: 9999
      }
    }
  }
}
</script>

<style scoped>
/* Directional spacing pulled out of inline style="" attributes so the RTL build
   (postcss-rtl on <style> blocks) can mirror them -- inline styles are invisible
   to that pipeline. */
.results-count-label {
  padding-top: 10px;
  float: right;
  font-size: 14px;
}
.clear-filter-icon {
  padding-left: 14px;
  padding-top: 7px;
}
.add-order-delivery-col {
  margin-left: auto;
}
/* Only the "Filter:" label needs the extra gap -- the other two
   .filter-field-auto elements (apply/cancel icon, result count) only need the
   align-self they already carry as an inline style (not direction-sensitive,
   since align-self applies to the cross/block axis, not the inline axis). */
.filter-label-gap {
  margin-right: 10px;
}

/* Consistent flex-wrap toolbar: overrides the Bootstrap col-sm/col-md grid
   (and the .mobile float rule below) so every action button gets the same
   height/spacing and wraps predictably instead of drifting across rows
   depending on which combination of buttons a given page enables. */
.toolbar-row {
  display: flex !important;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin: 0 !important;
}
.toolbar-row > div {
  width: auto !important;
  max-width: 100% !important;
  padding: 0 !important;
  float: none !important;
}
.toolbar-row .v-btn {
  height: 38px !important;
  min-width: 0 !important;
  margin: 0 !important;
  padding: 0 14px !important;
}

/* Buttons that used to rely on Bootstrap's text-right column alignment (e.g.
   Purchase/Verify/Approve, Delete Selected Orders, the CRUD "Add X" buttons)
   get pushed to the end of the flex row instead - margin-left:auto on a flex
   item consumes all remaining space to its left, so whichever one of these
   is actually rendered on a given page still lands on the right edge. */
.toolbar-row > div.text-right {
  margin-left: auto !important;
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}

@media screen and (max-width: 768px) {
  .mobile {
    float: left;
  }
}
.pointer {
  cursor: pointer;
}

.not-allowed {
  cursor: not-allowed;
}

.filter-branch-btn:hover {
  background-color: #2887e5 !important;
}

.animate-filter-branch-btn {
  animation: filter-branch-animation 0.4s 1;
}

@keyframes filter-branch-animation {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}

.customer-search-suggestions-list {
  margin: 0;
  padding: 4px 0;
  list-style: none;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  max-height: 260px;
  overflow-y: auto;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}
.customer-search-suggestion-item {
  padding: 6px 12px;
  cursor: pointer;
  font-size: 13px;
}
.customer-search-suggestion-item:hover {
  background: #f5f5f5;
}
</style>

<!-- Unscoped on purpose: pages inject their own filters into the
     custom-filter/custom-filter-start slots below, and slotted content keeps
     the PARENT component's scoped-css attribute, not this one's - so these
     shared sizing classes have to live outside <style scoped> to reach them. -->
<style>
/* max-width was capping growth too low - flex-grow:1 lets these fill leftover
   row space, but once every item hits its own max-width ceiling there's
   nothing left to absorb the remainder, so a row with only a few filters
   (e.g. Warehouse/Status/Payment/Date Type/Order Sort/Platform) stopped
   short of the container's full width instead of spreading out to fill it. */
.filter-field {
  flex: 1 1 170px !important;
  min-width: 150px !important;
  max-width: 320px !important;
}

.filter-field-wide {
  flex: 1 1 220px !important;
  min-width: 200px !important;
  max-width: 380px !important;
}

/* Small fixed-width controls (per-page count) that don't need to grow. */
.filter-field-narrow {
  flex: 0 1 100px !important;
  min-width: 80px !important;
  max-width: 120px !important;
}

/* Shrink-to-content items (the "Filter:" label, apply/cancel icon, the
   "Show X of Y Result" text) that should size to their own text, not stretch
   or claim a fixed column. */
.filter-field-auto {
  flex: 0 0 auto !important;
}

@media screen and (max-width: 600px) {
  .filter-field,
  .filter-field-wide,
  .filter-field-narrow {
    flex-basis: 100%;
    max-width: 100%;
  }
}

/* Opt-in via the noWrapFilters prop (creditLogAction.vue: keeps Search / Payment /
   Show-Hide Columns etc. on one line instead of the default wrap, which pushed later
   fields like Show/Hide Columns to a second row once enough filters were enabled).
   Not the default for every page — some already have enough filters that forcing
   nowrap would just overflow instead of wrapping, so this stays per-page opt-in
   rather than a change to .filter-field/.filter-field-wide's own default wrap. */
.filters-no-wrap {
  flex-wrap: nowrap !important;
  overflow-x: auto;
  overflow-y: hidden;
}
.filters-no-wrap > .filter-field,
.filters-no-wrap > .filter-field-wide,
.filters-no-wrap > .filter-field-narrow,
.filters-no-wrap > .filter-field-auto {
  flex-shrink: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/preDatatableComponent.vue